enum CompanionModalMode {
  CREATE = 'create',
  EDIT = 'edit',
}

export default CompanionModalMode;
